export default "__VITE_ASSET__EhWMJGSI__"